async function fetchWithTimeout(url, opts = {}, timeout = 60000) {
    const abortController = new AbortController();
    const { signal } = abortController;
    const _fetchPromise = fetch(url, {
        ...opts,
        signal
    });
    const timer = setTimeout(()=>abortController.abort(), timeout);
    try {
        const result = await _fetchPromise;
        clearTimeout(timer);
        return result;
    } catch (e) {
        clearTimeout(timer);
        throw e;
    }
}
export { fetchWithTimeout as default };
